import { LotType, LotTypeApi } from 'src/constants';
import type { ILot } from 'src/interfaces';

export const getLotLabel = (lotData: ILot) => {
  const isMausoleum =
    lotData.type === LotType[LotTypeApi.CRYPT] ||
    lotData.type === LotType[LotTypeApi.NICHE];
  return isMausoleum ? lotData.type : 'Lot';
};
